import { motion } from "framer-motion";
import React from "react";
import offpage from "../Images/frontend.png"; // You may want to replace these with appropriate icons for web development
import onpage from "../Images/backend.jpg"; 
import technical from "../Images/db.jpg"; 

const WebService = ({ icon, title, description, delay }) => (
  <motion.div
    className="bg-gradient-to-br from-blue-400 via-teal-500 to-teal-400 border border-teal-300 rounded-lg shadow-xl p-6 md:p-8 flex flex-col items-center text-center h-full transform transition-transform duration-[1s] hover:shadow-2xl hover:shadow-teal-400"
    initial={{ opacity: 0, x: -100 }} // Initial fade in from the left
    whileInView={{ opacity: 1, x: 0 }} // Fully visible when in view
    exit={{ opacity: 0, x: 100 }} // Fade out to the right when leaving view
    transition={{
      duration: 1.2, // Slow down for smoother animation
      ease: "easeInOut", // Use easing for smooth transitions
      delay: delay, // Stagger effect for each card
    }}
    viewport={{ once: false, amount: 0.2 }} // Replay animation when back in view
  >
    <div className="mb-6 w-full">
      <img
        src={icon}
        alt="Service Icon"
        className="rounded-lg w-full h-48 mx-auto border-4 border-white shadow-sm"
      />
    </div>
    <h3 className="text-lg font-bold text-white mb-4">{title}</h3>
    <ul className="text-white text-sm space-y-2">
      {description.map((item, index) => (
        <li key={index} className="leading-tight">
          {item}
        </li>
      ))}
    </ul>
  </motion.div>
);

const WebServices = () => {
  const services = [
    {
      icon: offpage, // Replace with a relevant icon for Frontend
      title: "Frontend",
      description: [
        "Account Creation & Setup",
        "Profile Optimization (Bio, Profile Picture, Links)",
        "Branding & Visual Identity Alignment",
        "Custom Cover & Profile Graphics",
      ],
    },
    {
      icon: onpage, // Replace with a relevant icon for Backend
      title: "Backend",
      description: [
        "Content Calendar Creation",
        "Automated Scheduling & Posting",
        "Platform-Specific Content Adaptation",
        "Consistent Posting Frequency",
      ],
    },
    {
      icon:technical , // Replace with a relevant icon for Database
      title: "Database",
      description: [
        "Daily Monitoring & Engagement",
        "Responding to Comments & Messages",
        "Proactive Audience Interaction",
        "Building Relationships with Followers",
      ],
    },
  ];

  return (
    <div className="w-full px-4 py-12">
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-4 text-teal-600">
        Our Web Development Services
      </h1>
      <p className="text-xl text-center text-teal-500 mb-12">
        Increase Your Search Rankings and Get Discovered More Online
      </p>
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {services.map((service, index) => (
          <WebService key={index} {...service} delay={index * 0.2} />
        ))}
      </div>
    </div>
  );
};

export default WebServices;
